import { Font, Theme } from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../constants/ColorConstants';
import BreakpointConstants from '@oneamerica/dxp-ui-module-my-profile/src/constants/BreakpointConstants';

const styles = (width: number) => {
  const fieldContainerWidth =
    BreakpointConstants.isLG(width) || BreakpointConstants.isMD(width)
      ? '65%'
      : '100%';

  return Theme.Responsive.create({
    colorBlue: {
      color: Theme.Color.oaBlue,
    },
    formContainer: {
      marginTop: 16,
      paddingBottom: 20,
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: '500',
      marginBottom: 16,
    },
    fieldContainer: {
      marginBottom: 20,
      width: fieldContainerWidth,
    },
    fieldLabel: {
      fontSize: 14,
      fontWeight: '500',
      marginBottom: 10,
    },
    radioGroup: {
      flexDirection: 'row',
      gap: 16,
      marginTop: 8,
    },
    radioGroupalignment: {
      marginLeft: -10,
      paddingLeft: 0,
    },
    buttonContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      marginTop: 24,
      gap: 12,
    },
    cancelbutton: {
      minWidth: 100,
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
      paddingHorizontal: 12,
      borderColor: ColorConstants.oaBlue,
    },
     horizontalDivider: {
      backgroundColor: ColorConstants.grey200,
      height: 1,
      width: '100%',
      marginBottom: 25,
    },
    horizontalDividerTitle: {
      backgroundColor: ColorConstants.grey200,
      height: 1,
      width: '100%',
    },
    alertBannerContentMargin: { marginTop: 10, marginBottom: 10 },
    phnlinkStyle: {
      color: ColorConstants.oaBlueTint,
      fontSize: 14,
      fontFamily: Font.medium.fontFamily,
      //@ts-ignore
      display: 'inline-flex',
    },
    marginTop16: {
      marginTop: 16,
    },
  })();
};

export default styles;
